import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { BptSearchModule } from 'bpt-ui-library/bpt-search';
import { TooltipModule } from 'primeng/tooltip';
import { DocumentLibrarySearchComponent } from './document-library-search/document-library-search.component';
import { DocumentsPanelListComponent } from './documents-panel-list/documents-panel-list.component';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { EmptyResultsComponent } from '../shared-components/empty-results/empty-results.component';
import { SpinnerComponent } from '../shared-components/spinner/spinner.component';
import { PanelHubComponent } from '../shared-components/panel-hub/panel-hub.component';

@NgModule({
  declarations: [DocumentLibrarySearchComponent,DocumentsPanelListComponent],
  imports: [
    CommonModule,
    SharedModule,
    BptSearchModule,
    TooltipModule,
    CheckboxModule,
    FormsModule,
    ToastModule,
    EmptyResultsComponent,
    SpinnerComponent,
    PanelHubComponent
  ],
  exports: [DocumentLibrarySearchComponent,DocumentsPanelListComponent]
})
export class DocumentSearchModule { }
